// Lives in its own file (not inline in sensorAssignmentsFeature.ts) so route
// factories and screens can import these constants without a circular import
// back through sensorAssignmentsFeature.ts -> presentation/routes -> here.
const SENSOR_ASSIGNMENT_LIST =
  "core.sensor_assignment_management.sensor_assignment_list";

export const SENSOR_ASSIGNMENTS_VIEW = `${SENSOR_ASSIGNMENT_LIST}.view`;
export const SENSOR_ASSIGNMENTS_CREATE = `${SENSOR_ASSIGNMENT_LIST}.create`;
export const SENSOR_ASSIGNMENTS_UPDATE = `${SENSOR_ASSIGNMENT_LIST}.update`;
export const SENSOR_ASSIGNMENTS_DELETE = `${SENSOR_ASSIGNMENT_LIST}.delete`;

// Irregular: the backend's screen segment for sensors is `sensor` under
// device_management, not `sensor_list` -- it grants only create/view, no
// update or delete. This is what gates the Sensors Management list (the
// permission catalog entry for it stays with devicesFeature, since the
// segment belongs to the backend's device_management tree).
export const SENSORS_VIEW = "core.device_management.sensor.view";
